;(function($, window, document){
    window.NewsletterPopup = Me.view.extend({
        options: {
        },

        initialize: function() {
            _.bindAll(this, 'closePopupHandler', 'openPopupHandler');

            var cookie = Cookies.get('newsletter_subscribed');

            if(typeof cookie === 'undefined'){
                this.addEvents();
            }
        },
        addEvents: function() {
            this.$el.on('click', this.closePopupHandler);
            Me.dispatch.subscribe('product.open_popup', this.openPopupHandler)
        },
        openPopupHandler: function(){
            $("html, body").animate({ scrollTop: 0 });
            this.$el.removeClass('hidden');
            $('body').addClass('no-scroll');
        },
        closePopupHandler: function(e){
            var targetId = $(e.target).attr('id');

            // If the user clicks on the backdrop or the close button only
            if(targetId === this.$el.attr('id') || targetId === this.$('.close-button svg').attr('id') || $(e.target).hasClass('close-button')){
                this.$el.addClass('hidden');
                $('body').removeClass('no-scroll');
            }
        }
    });
}(jQuery, window, document));
